import { getSrc } from '~app/helpers/assetLoading';
import { AUDIENCE_CTA, BUILD_WITH_AI_CTA, ENTERPRISE_CTA } from '~app/components/constants';
import AudienceIMG from '~static/images/existingUser/audience.webp';
import BuildWithAI from '~static/images/existingUser/build-with-ai.webp';
import Solution from '~static/images/existingUser/solutions.webp';

export const MAIN_HEADING_COPY = 'SurveyMonkey is more powerful than you think';

export const UPDATED_CARDS_COPY = [
  {
    amplitudeEvent: 'experiment event',
    header: 'Let AI do the work for you',
    subHeader: 'Create surveys in under a minute and get insights fast.',
    ctaText: 'Try Build with AI',
    ctaURL: BUILD_WITH_AI_CTA,
    ctaUsage: 'build with ai cta',
    image: {
      src: getSrc(BuildWithAI),
      alt: 'AI survey creation',
    },
  },
  {
    amplitudeEvent: 'endpage user interaction',
    header: 'Reach your target market',
    subHeader: 'Send your survey to exactly the right people using our global panel, starting at $1 USD per response.',
    ctaText: 'Choose your audience',
    ctaURL: AUDIENCE_CTA,
    ctaUsage: 'market research cta',
    image: {
      src: getSrc(AudienceIMG),
      alt: 'Audience targeting',
    },
  },
  {
    amplitudeEvent: 'endpage user interaction',
    header: 'Discover our Enterprise solution',
    subHeader: 'Drive decisions at scale with SurveyMonkey Enterprise, trusted by 260K+ organizations worldwide.',
    ctaText: 'Explore solution',
    ctaURL: ENTERPRISE_CTA,
    ctaUsage: 'enterprise cta',
    image: {
      src: getSrc(Solution),
      alt: 'Enterprise solution',
    },
  },
];
